/* globals google */
'use strict';

module.exports = {
    init: function () {
        var mapCanvas = document.querySelector('.map-canvas');
        // Check if map is visible on screen. Do not invoke Google maps service if map is not visible.
        // This reduces the number of Google APIs invoked
        var style = window.getComputedStyle(mapCanvas);
        if (style.display === 'none') {
            return;
        }

        // Load the google maps with the marker on the store location
        var latlng = new google.maps.LatLng(Number(mapCanvas.dataset.defaultlat), Number(mapCanvas.dataset.defaultng)); // eslint-disable-line
        var googleMapId = mapCanvas.dataset.mapid;
        var mapOptions = {
            scrollwheel: false,
            zoom: 16,
            center: latlng,
            mapId: googleMapId
        };
        var map = new google.maps.Map(mapCanvas, mapOptions);

        var marker = new google.maps.Marker({ // eslint-disable-line
            position: latlng,
            map: map
        });
        var infowindow = new google.maps.InfoWindow();

        google.maps.event.addListener(marker, 'click', function () {
            var markerData = $('.jumbotron').attr('data-markerData');
            markerData = JSON.parse(markerData);
            infowindow.setContent(markerData.data);
            infowindow.open(map, marker);
          });
    }
};
